// 2_components/products_block_standard_price.js
// Moves the crossed-out standard (pre-discount) price next to the final price on
// each discounted product card, re-running on Shoptet/favorites/Raventic loads.

export function init() {
	productsBlockStandardPrice();

	document.addEventListener("ShoptetDOMContentLoaded", function () {
		productsBlockStandardPrice();
	});

	document.addEventListener("ShoptetDOMPageMoreProductsLoaded", function () {
		productsBlockStandardPrice();
	});

	document.addEventListener("dkLabFavouriteProductsLoaded", function () {
		productsBlockStandardPrice();
	});

	document.addEventListener("RAVENTIC SEARCH RESULTS TRANSFORMED", function () {
		productsBlockStandardPrice();
	});
}

function productsBlockStandardPrice() {
	const allProductsInProductsBlock = document.querySelectorAll(".products-block .product");
	if (!allProductsInProductsBlock || allProductsInProductsBlock.length === 0) {
		return; // No products found
	}
	allProductsInProductsBlock.forEach((product) => {
		if (product.classList.contains("standard-price-moved")) {
			return; // Skip if already processed
		}
		product.classList.add("standard-price-moved");

		const standardPrice = product.querySelector(".flag-discount .price-standard");
		const finalPrice = product.querySelector(".price-final");
		if (standardPrice && finalPrice) {
			finalPrice.appendChild(standardPrice);
		}
	});
}
